import React, { useState } from 'react';
import { Card, CardHeader, CardContent, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { LoadingSpinner } from '../ui/loading-spinner';
import StripeCheckout from './StripeCheckout'; // Import StripeCheckout for plan display

/**
 * Component to display when a user's trial has ended and they need to subscribe
 */
const TrialEndedNotice = ({
  loading,
  refreshing,
  onRefresh,
  onManageSubscription,
  onSelectPlan,
  stripeCustomerId,
  availedTrials = {}, // FIX: Default to empty object, not {basic: true}
  showManageButton = false // New prop to control showing the manage button
}) => {
  // Add local state for expandable PRO section
  const [showProDetails, setShowProDetails] = useState(false);

  return (
    <div className="space-y-6">
      <Card className="app-card-bg border-border">
        <CardHeader>
          <CardTitle className="text-accent-foreground">
            Your Trial Has Ended
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-primary">
            Your free trial has ended. Subscribe to continue using all features.
          </p>
          <p className="text-muted-foreground text-sm mb-2">
            Choose a subscription plan below to continue using all features.
          </p>
          
          {/* Only show the Manage Subscription button if explicitly enabled and stripeCustomerId exists */}
          {showManageButton && stripeCustomerId && (
            <>
              <Button 
                onClick={onManageSubscription} 
                className="w-full app-accent-purple-bg hover:app-accent-purple-hover text-white" 
                disabled={loading || refreshing}
              >
                {(loading || refreshing) ? <LoadingSpinner size="small" /> : 'Manage Previous Subscription'}
              </Button>
              <p className="text-xs text-muted-foreground mt-1 text-center">
                Access settings for your previous subscription
              </p>
            </>
          )}
          
          <Button 
            onClick={onRefresh} 
            variant="outline" 
            className="w-full mt-2 text-primary border-border hover:bg-muted" 
            disabled={refreshing || loading}
          >
            {refreshing ? <LoadingSpinner size="small" /> : 'Refresh Status'}
          </Button>
        </CardContent>
      </Card>
      
      {/* Use StripeCheckout for consistent plan display */}
      <Card className="app-card-bg border-border">
        <CardHeader>
          <CardTitle className="text-accent-foreground">
            Subscription Plans
          </CardTitle>
        </CardHeader>
        <CardContent>
          {/* Add expandable PRO upgrade section */}
          <div className="mb-4">
            <button
              className="text-sm text-purple-700 dark:text-purple-300 underline hover:text-purple-900 transition-colors"
              onClick={() => setShowProDetails((v) => !v)}
              aria-expanded={showProDetails}
              aria-controls="pro-benefits-panel"
            >
              {showProDetails ? "Hide PRO Benefits" : "See PRO Benefits & Upgrade"}
            </button>
            {showProDetails && (
              <div
                id="pro-benefits-panel"
                className="mt-2 p-3 rounded bg-purple-50 dark:bg-purple-900/30 border border-purple-200 dark:border-purple-700"
              >
                <ul className="text-sm text-purple-900 dark:text-purple-100 mb-2 list-disc pl-5">
                  <li>Advanced analytics & reporting</li>
                  <li>Priority support</li>
                  <li>Unlimited invoices & clients</li>
                  {/* Add/adjust benefits as needed */}
                </ul>
                <Button
                  className="w-full app-accent-purple-bg hover:app-accent-purple-hover text-white"
                  onClick={() => onSelectPlan && onSelectPlan('pro', false)}
                  disabled={loading}
                >
                  Upgrade to PRO
                </Button>
              </div>
            )}
          </div>
          {/* Use StripeCheckout component with forced availedTrials to ensure 
              it shows subscription buttons instead of trial buttons */}
          <StripeCheckout
            loading={loading}
            availedTrials={availedTrials}
            onSelectPlan={onSelectPlan}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default TrialEndedNotice;
